const ProjectData = [
  {
    id: "01",
    key: "1",
    title: "Scribble ChatApp",
    details:
      "Scribble is a real-time chat application built using ReactJS, NodeJS, ExpressJS, Socket.io, and MongoDB. It is a fully functional chat application with features like sending scribbled images to your friends.",
    link: "github.com/InTruder-Sec/scribble-chat-app",
    linkText: "Scribble Chat App",
    tools: [
      "HTML5",
      "CSS3",
      "JavaScript",
      "React",
      "ExpressJS",
      "NodeJS",
      "Socket.io",
      "MongoDB",
    ],
  },
  {
    id: "02",
    key: "2",
    title: "Prohub",
    details:
      "Prohub is an extended version of Github, helping students and professionals to find right open source projects near them.",
    link: "github.com/InTruder-Sec/prohub-os-project-finder",
    linkText: "Prohub",
    tools: [
      "React",
      "ShadCn/UI",
      "Tailwind",
      "ExpressJS",
      "NodeJS",
      "Socket.io",
      "MongoDB",
      "Appwrite",
    ],
  },
  {
    id: "03",
    key: "3",
    title: "Playify",
    details:
      "Playify a unique spotify clone built using ReactJS and Spotify API. You can explore new songs, artists, and albums. Search for your favorite songs and enjoy listening to them.",
    link: "github.com/InTruder-Sec/playifyi-music-explorer",
    linkText: "Playify",
    tools: ["HTML5", "CSS3", "JavaScript", "React", "Spotify API"],
  },
  {
    id: "04",
    key: "4",
    title: "Iconic Hashing Algorithm",
    link: "github.com/InTruder-Sec/IHA",
    linkText: "IHA Github",
    details:
      "Iconic Hashing Algorithm is a hashing algorithm built using Python3. It is a unique hashing algorithm that uses the concept of MD5 hashing to generate a unique hash for any string.",
    tools: ["Python3"],
  },
  {
    id: "05",
    key: "5",
    title: "Web Dev Projects",
    details:
      "This is a collection of all the web development projects that I have built. It includes projects like To do list, Calculator, Weather App, Snake Game, etc.",
    link: "github.com/InTruder-Sec/Full-StackDev-Projects",
    linkText: "Web Dev Projects",
    tools: [
      "HTML5",
      "CSS3",
      "JavaScript",
      "React",
      "ExpressJS",
      "NodeJS",
      "Socket.io",
      "MongoDB",
      "Appwrite",
    ],
  },
];

export default ProjectData;
